import {sso} from "./SSOUtil";

module.exports = function (result) {
    if (result['status'] === 401) {
        sso.logout();
    }
};



// WEBPACK FOOTER //
// ./src/util/ErrorCode.js